import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { adminApi, getApiErrorMessage } from '../services/adminApi'
import { Alert, Badge, FormActions, FormSection, PageHeader, Select, Spinner, Textarea } from '../components/ui'

const statusLabels = { new: 'Nova', in_review: 'Em análise', resolved: 'Resolvida', ignored: 'Ignorada' }
const categoryLabels = { error: 'Erro', complaint: 'Reclamação', missing_help: 'Ajuda ausente', suggestion: 'Sugestão', other: 'Outro' }

export default function MaviFeedback() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [item, setItem] = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    adminApi.listMaviFeedback({})
      .then((response) => {
        const items = response?.data?.data ?? response?.data ?? []
        const found = items.find((entry) => String(entry.id) === String(id))
        if (!found) throw new Error('Situação da Mavi não encontrada.')
        if (active) setItem(found)
      })
      .catch((err) => active && setError(getApiErrorMessage(err, 'Não foi possível carregar a situação.')))
      .finally(() => active && setLoading(false))
    return () => { active = false }
  }, [id])

  async function submit(event) {
    event.preventDefault()
    if (!item || saving) return
    setSaving(true)
    setError('')
    try {
      await adminApi.updateMaviFeedback(item.id, { status: item.status, adminNote: item.admin_note || '' })
      navigate('/mavi', { replace: true, state: { message: 'Pendência atualizada.' } })
    } catch (err) {
      setError(getApiErrorMessage(err))
    } finally {
      setSaving(false)
    }
  }

  if (loading) return <Spinner label="Carregando situação da Mavi…" />

  return (
    <form onSubmit={submit} className="space-y-6">
      <PageHeader eyebrow="Mavi" title={`Situação MAVI-${id}`} description="Analise o relato encaminhado e registre o tratamento realizado." icon="fa-wand-magic-sparkles" />
      {error && <Alert type="error">{error}</Alert>}
      {item && (
        <>
          <FormSection title="Contexto recebido" description={`Base: ${item.tenant_id}${item.current_path ? ` · Tela: ${item.current_path}` : ''}`} icon="fa-circle-info">
            <div className="flex flex-wrap gap-2">
              <Badge tone="info">{categoryLabels[item.category] || item.category}</Badge>
              <Badge>{item.occurrence_count || 0} ocorrência(s)</Badge>
            </div>
            <h3 className="mt-4 font-semibold text-brand-deep">{item.title}</h3>
            <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-slate-600">{item.summary}</p>
          </FormSection>
          <FormSection title="Tratamento" description="Atualize a situação e deixe uma anotação para a equipe." icon="fa-list-check">
            <div className="space-y-4">
              <Select label="Situação" value={item.status} onChange={(e) => setItem({ ...item, status: e.target.value })}>
                {Object.entries(statusLabels).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
              </Select>
              <Textarea label="Anotação da equipe" rows={7} value={item.admin_note || ''} onChange={(e) => setItem({ ...item, admin_note: e.target.value })} />
            </div>
          </FormSection>
          <FormActions onCancel={() => navigate('/mavi')} saving={saving} submitLabel="Salvar tratamento" />
        </>
      )}
    </form>
  )
}
